import React, { useEffect, useState } from "react";
import { useSession } from "../SessionContext";
import {
  IconDeviceDesktopAnalytics,
  IconMessageCircle2,
  IconMicrophone,
  IconChartPie,
} from "@tabler/icons-react";

//const IP = "http://localhost:8000";
const IP = "https://reportes.aux-rolplay.com";

const Sidebar = ({ setView, activeView }) => {
  const { id_user, key } = useSession();
  const [menuPermissions, setMenuPermissions] = useState({
    mod_simulador: false,
    mod_simulador_feedback: false,
    mod_rolplay: false, // Add this permission
  });

  const handleViewChange = (view) => {
    setView(view);
  };

  useEffect(() => {
    if (id_user && key) {
      // Modo dummy: simular autorización cuando id y key son "00"
      if (id_user === "00" && key === "00") {
        setMenuPermissions({
          mod_simulador: true,
          mod_simulador_feedback: false,
          mod_rolplay: true,
        });
        return;
      }

      // Modo normal: llamar al endpoint real
      fetch(
        `${IP}/check-user-authorization_menu/?user_id=${id_user}&key=${key}`,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "authorized") {
            setMenuPermissions({
              mod_simulador: data.result.mod_simulador === 1,
              mod_simulador_feedback: data.result.mod_simulador_feedback === 1,
              mod_rolplay: data.result.mod_rolplay === 1, // Add this permission check
            });
          }
        })
        .catch((error) =>
          console.error(
            "Error checking authorization for Menu options:",
            error,
          ),
        );
    }
  }, [id_user, key]);

  return (
    <div className="w-[250px] h-auto p-5 flex flex-col text-white justify-start rounded-[25px] mt-[0.5%] mb-[0.5%] ml-[0.5%] bg-gradient-to-b from-[#991b1b] via-[#b91c1c] to-[#dc2626]">
      <div className="mb-8">
        <img src="/logo.svg" alt="Logo" className="w-full" draggable="false" />
      </div>

      <h2 className="text-sm font-bold mb-1 mt-5 text-white/90">Menu</h2>
      <ul className="list-none p-0 m-0">
        {(key === "zBeMrw23" || key === "WF5GHtHy3" || key === "BNn3s56A" || key === "JIn0ds12a") && (
          <li
            onClick={() =>
              handleViewChange(
                key === "zBeMrw23" ? "Dashboard" :
                  key === "WF5GHtHy3" ? "DashboardLacoste" :
                    key === "BNn3s56A" ? "DashboardSomos" :
                      "DashboardInter"
              )
            }
            className={`py-2 text-sm cursor-pointer flex items-center relative hover:bg-white/15 hover:rounded-2xl hover:px-5 transition-all duration-300`}
          >
            <IconChartPie
              size={20}
              className="mr-2.5 text-white/75"
              stroke={1.5}
            />
            <span>
              {key === "zBeMrw23" ? "Métricas" :
                key === "WF5GHtHy3" ? "Métricas Lacoste" :
                  key === "BNn3s56A" ? "Métricas Somos" :
                    "Métricas"}
            </span>
            {((activeView === "Dashboard" && key === "zBeMrw23") ||
              (activeView === "DashboardLacoste" && key === "WF5GHtHy3") ||
              (activeView === "DashboardSomos" && key === "BNn3s56A") ||
              (activeView === "DashboardInter" && key === "JIn0ds12a")) && (
                <span className="absolute right-2.5 w-2.5 h-2.5 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.8)]"></span>
              )}
          </li>
        )}

        {menuPermissions.mod_simulador && (
          <li
            onClick={() =>
              handleViewChange(
                key === "H1te2s03s"
                  ? "SimulatorHeineken"
                  : menuPermissions.mod_simulador_feedback
                    ? "simuladorfeed"
                    : "Simulator"
              )
            }
            className={`py-2 text-sm cursor-pointer flex items-center relative hover:bg-white/15 hover:rounded-2xl hover:px-5 transition-all duration-300`}
          >
            <IconDeviceDesktopAnalytics
              size={20}
              className="mr-2.5 text-white/75"
              stroke={1.5}
            />
            <span>Hist. Simulador</span>
            {(activeView === "Simulator" || activeView === "simuladorfeed" || activeView === "SimulatorHeineken") && (
              <span className="absolute right-2.5 w-2.5 h-2.5 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.8)]"></span>
            )}
          </li>
        )}

        {menuPermissions.mod_rolplay && (
          <li
            onClick={() => handleViewChange("Rolplay")}
            className={`py-2 text-sm cursor-pointer flex items-center relative hover:bg-white/15 hover:rounded-2xl hover:px-5 transition-all duration-300`}
          >
            <IconMicrophone
              size={20}
              className="mr-2.5 text-white/75"
              stroke={1.5}
            />
            <span>
              {key === "Ko3a244ASp" ? "Presentación" : "Hist. Rolplay"}
            </span>
            {activeView === "Rolplay" && (
              <span className="absolute right-2.5 w-2.5 h-2.5 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.8)]"></span>
            )}
          </li>
        )}
      </ul>

      <h2 className="text-sm font-bold mb-1 mt-5 text-white/90">Ayuda</h2>
      <ul className="list-none p-0 m-0">
        <li
          onClick={() => handleViewChange("message")}
          className={`py-2 text-sm cursor-pointer flex items-center relative hover:bg-white/15 hover:rounded-2xl hover:px-5 transition-all duration-300`}
        >
          <IconMessageCircle2
            size={20}
            className="mr-2.5 text-white/75"
            stroke={1.5}
          />
          <span>Mensaje</span>
          {activeView === "message" && (
            <span className="absolute right-2.5 w-2.5 h-2.5 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.8)]"></span>
          )}
        </li>
      </ul>

      <div className="text-center text-xs text-white/75 mt-auto">
        <p className="mb-2">Software manager for Administrators. Powered by</p>
        <img src="/logo_mini.svg" alt="Rolplay" className="w-6 h-6 mx-auto" />
      </div>
    </div>
  );
};

export default Sidebar;
